// extracted by mini-css-extract-plugin
export default {"panel":"Notifications_panel__WopT+","read-icon":"Notifications_read-icon__IqZLi","unread":"Notifications_unread__e-9OG"};